import React, { useState, useEffect } from "react";
import { Button, Box, VStack, useTheme, useToast, useColorModeValue } from "@chakra-ui/react";
import { DownloadIcon } from "@chakra-ui/icons"; // You can replace this with an appropriate CSV/Excel icon
import { isDemoSupplier, getDemoUrl } from "../../../tools/demoConfig";

const Exports = ({ supplier, retailer,week_ending_date,dd_uuid }) => {
  const [showButtons, setShowButtons] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const theme = useTheme();
  const toast = useToast();
  const dropdownBg = useColorModeValue("white", "gray.800");

  const fetchCsv = async (vars, url, name) => {
    if (isDemoSupplier(supplier)) url = getDemoUrl(url);
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(vars),
    };

    try {
      setIsLoading(true);
      const response = await fetch(url, requestOptions);
      setIsLoading(false);

      const contentType = response.headers.get("content-type");
      console.log("contentType: ", contentType);
      if (contentType && (contentType.includes("text/csv") || contentType.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"))) {
        const blob = await response.blob();
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `${name}_${vars.supplier}_${vars.retailer}_${vars.week_ending_date}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        toast({
          title: "Success",
          description: `${name} file downloaded successfully.`,
          status: "success",
          duration: 5000,
          isClosable: true,
        });
      } else {
        console.log("error", response);
        toast({
          title: "Error",
          description: "An error occurred while downloading the file.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Fetch error:", error);
      setIsLoading(false);
      toast({
        title: "Technical Error",
        description: "A technical error occurred.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const handleStrikeRateClick = async () => {
    try {
      const url = `${process.env.REACT_APP_API_URL}/rep_strikeRate/strike-csv1`;
      const name = "Strike Rate";
      const vars = { supplier, retailer, userid: localStorage.getItem("userid"),week_ending_date,dd_uuid };
      await fetchCsv(vars, url, name);
    } catch (error) {
      console.error("Error fetching table data:", error);
    }
  };

  const handleStoreSOHClick = async () => {
    try {
      const url = `${process.env.REACT_APP_API_URL}/rep_sales/sales_csv2`;
      const name = "Store SOH Per Region";
      const vars = { supplier, retailer, userid: localStorage.getItem("userid") };
      await fetchCsv(vars, url, name);
    } catch (error) {
      console.error("Error fetching table data:", error);
    }
  };

  const handleTop10Click = async () => {
    try {
      const url = `${process.env.REACT_APP_API_URL}/rep_sales/sales_csv3`;
      const name = "Top 10 Highest SOH Value";
      const vars = { supplier, retailer, userid: 1 };
      await fetchCsv(vars, url, name);
    } catch (error) {
      console.error("Error fetching table data:", error);
    }
  };

  useEffect(() => {
    if (showButtons) {
      const timer = setTimeout(() => {
        setShowButtons(false);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [showButtons]);

  return (
    <Box position="relative" onMouseEnter={() => setShowButtons(true)} onMouseLeave={() => setShowButtons(false)} bg={dropdownBg} p={2} borderRadius={12}>
      <Button
        leftIcon={<DownloadIcon />}
        bg={theme.colors.primary1}
        _hover={{ bg: `${theme.colors.secondary1} !important`, color: "black !important" }}
        color="white"
        variant="solid"
        isLoading={isLoading}
      >
        Export
      </Button>
      {showButtons && (
        <VStack position="absolute" top="100%" left={0} mt={1} bg={dropdownBg} p={2} borderRadius={12} shadow="lg" zIndex={2001} >
          <Button
            w="100%"
            bg={theme.colors.primary1}
            _hover={{ bg: `${theme.colors.secondary1} !important`, color: "black !important" }}
            color="white"
            variant="outline"
            onClick={handleStrikeRateClick}
          >
            Strike Rate 
          </Button>
        </VStack>
      )}
    </Box>
  );
};

export default Exports;
